/* GoClove PLP — Card: media swap, swatch apply, sizes, card state init */
(function () {
  if (window.__GOC_PLP_CARD__) return;
  window.__GOC_PLP_CARD__ = true;

  window.__GOC_PLP__ = window.__GOC_PLP__ || {};
  const GOC = window.__GOC_PLP__;

  const _preloaded = new Set();

  function preloadImage(url) {
    if (!url || _preloaded.has(url)) return;
    _preloaded.add(url);
    const link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "image";
    link.href = url;
    document.head.appendChild(link);
  }

  function preloadSwatchImages(btn) {
    const img1 = btn.getAttribute("data-sp-img1");
    const img2 = btn.getAttribute("data-sp-img2");
    if (img1) preloadImage(img1);
    if (img2) preloadImage(img2);
  }

  function setDesktopImages(card, img1, img2) {
    const ratioInner = card.querySelector(".gpcard__mediaDesktop .gpcard__ratioInner");
    if (!ratioInner) return;
    const main = ratioInner.querySelector("img.gpcard__imgMain");
    const alt = ratioInner.querySelector("img.gpcard__imgAlt");
    if (main && img1) {
      const tempImg = new Image();
      tempImg.src = img1;
      if (tempImg.decode) {
        tempImg.decode().then(() => { main.src = img1; }).catch(() => { main.src = img1; });
      } else {
        main.src = img1;
      }
    }
    if (alt) alt.src = img2 || img1 || alt.src;
  }

  function rebuildMobileSlides(card, img1, img2) {
    const swiperEl = card.querySelector(".gpcard__mediaMobile [data-gpcard-swiper]");
    if (!swiperEl) return;
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    wrapper.innerHTML =
      `<div class="swiper-slide">
        <div class="gpcard__ratio"><div class="gpcard__ratioInner">
          <img class="gpcard__img gpcard__imgMain" src="${img1}" alt="" loading="eager">
        </div></div>
      </div>
      <div class="swiper-slide">
        <div class="gpcard__ratio"><div class="gpcard__ratioInner">
          <img class="gpcard__img gpcard__imgMain" src="${img2 || img1}" alt="" loading="eager">
        </div></div>
      </div>`;

    if (swiperEl.swiper) {
      swiperEl.swiper.update();
      swiperEl.swiper.slideTo(0, 0);
    } else {
      const { ensureCardSwiper } = GOC;
      if (ensureCardSwiper) ensureCardSwiper(swiperEl);
    }
  }

  function isMeaningfulImgSrc(src) {
    if (!src) return false;
    const s = String(src).trim();
    if (!s || s.startsWith("data:") || s.includes("placeholder")) return false;
    return true;
  }

  function cardHasRealImage(card) {
    const img =
      card.querySelector(".gpcard__mediaDesktop img.gpcard__imgMain") ||
      card.querySelector(".gpcard__mediaMobile img.gpcard__imgMain");
    if (!img) return false;
    const src = img.getAttribute("src") || "";
    if (!isMeaningfulImgSrc(src)) return false;
    return img.complete && img.naturalWidth > 1;
  }

  function isNoSwatchCard(card) {
    if (!card) return false;
    const { LABELS } = GOC;
    const id = (LABELS.noSwatchIdentifier || "").toLowerCase();
    const cssClass = LABELS.noSwatchCssClass || "gpcard--no-swatches";
    if (card.classList.contains(cssClass)) return true;
    if (id) {
      const h = (card.dataset.baseHandle || card.dataset.activeHandle || "").toLowerCase();
      if (h.includes(id)) return true;
    }
    const swWrap = card.querySelector(".gpcard__swatches");
    if (!swWrap) return true;
    if (!swWrap.querySelector(".gpcard__swatch")) return true;
    return false;
  }

  function initNoSwatchCardImages(card) {
    if (!card) return;
    const baseImg1 = card.dataset.baseImg1 || card.getAttribute("data-base-img1") || "";
    const baseImg2 = card.dataset.baseImg2 || card.getAttribute("data-base-img2") || "";
    if (cardHasRealImage(card)) return;
    if (baseImg1) {
      setDesktopImages(card, baseImg1, baseImg2 || baseImg1);
      rebuildMobileSlides(card, baseImg1, baseImg2 || baseImg1);
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  // Wrap Men's/Women's (straight or curly apostrophe) in .gpcard__title-gender.
  // Women's must run before Men's — "Women's" contains "Men's" as a substring.
  function formatCardTitle(title) {
    if (!title) return "";
    let html = escapeHtml(title);
    html = html.replace(/Women(?:&#39;|’)s/g, "<span class=\"gpcard__title-gender\">$&</span>");
    html = html.replace(/Men(?:&#39;|’)s/g, "<span class=\"gpcard__title-gender\">$&</span>");
    return html;
  }


  function buildSizesFromVariants(card, variantsEnc, sizeIndex) {
    const { SELECTORS, qs, decodeVariants } = GOC;
    const wrap = qs(card, SELECTORS.sizesWrap);
    if (!wrap) return;
    const variants = decodeVariants(variantsEnc);
    const idx = Number(sizeIndex || 0);

    // B2C PREORDER DATE CUTOFF: a variant whose pre-order date is too far out is treated as unavailable here too.
    const blockedMap = window.GOCBlockedVariants || {};
    function isBlocked(v) {
      return !!(v && (v.blocked === true || blockedMap[v.id] || blockedMap[String(v.id)]));
    }

    const map = new Map();
    variants.forEach((v) => {
      if (!v || !v.options || typeof v.options[idx] === "undefined") return;
      const size = v.options[idx];
      if (!size) return;
      if (!map.has(size)) map.set(size, { available: false, id: null, price: null, cap: 0, promo: false });
      const item = map.get(size);
      if (v.available && !isBlocked(v) && !item.available) {
        item.available = true;
        item.id = v.id;
        item.price = (v.price != null) ? Number(v.price) : null;
        item.cap = Number(v.cap || 0);
        item.promo = !!v.promo;
      }
    });

    wrap.innerHTML = "";
    Array.from(map.keys()).forEach((size) => {
      const item = map.get(size);
      const b = document.createElement("button");
      b.type = "button";
      b.className = "gpcard__sizeBtn" + (item.available ? "" : " is-disabled") + (item.available && item.promo ? " is-promo" : "");
      b.textContent = size;
      b.setAttribute("data-size", size);
      if (item.id) b.setAttribute("data-variant-id", String(item.id));
      wrap.appendChild(b);
    });
  }

  function applySwatchToCard(btn, card) {
    if (!btn || !card) return;
    const { SELECTORS, qsa: _qsa } = GOC;

    _qsa(card, ".gpcard__swatch").forEach((s) => s.classList.remove("is-active"));
    btn.classList.add("is-active");

    const handle = btn.getAttribute("data-sp-handle") || "";
    const title = btn.getAttribute("data-sp-card-title") || "";
    const subtitle = btn.getAttribute("data-sp-subtitle") || btn.getAttribute("data-sp-title") || "";
    const baseImg1 = card.dataset.baseImg1 || "";
    const baseImg2 = card.dataset.baseImg2 || "";
    const img1 = btn.getAttribute("data-sp-img1") || baseImg1 || "";
    const img2 = btn.getAttribute("data-sp-img2") || baseImg2 || img1 || "";
    const hasAlt = btn.getAttribute("data-sp-has-alt") || "0";
    const sizeIndex = btn.getAttribute("data-sp-size-index") || card.dataset.sizeIndex || "0";
    const variantsEnc = btn.getAttribute("data-sp-variants") || "";
    const badge = btn.getAttribute("data-sp-badge") || "";
    const badgeStyle = btn.getAttribute("data-sp-badge-style") || "";
    const benefit = btn.getAttribute("data-sp-benefit") || "";

    if (hasAlt === "1" && img2 && img2 !== img1) card.classList.remove("gpcard--no-alt");
    else card.classList.add("gpcard--no-alt");

    if (img1) {
      const desktopEl = card.querySelector(".gpcard__mediaDesktop");
      const mobileEl = card.querySelector(".gpcard__mediaMobile");
      const desktopVisible = desktopEl && desktopEl.offsetParent !== null;
      const mobileVisible = mobileEl && mobileEl.offsetParent !== null;
      if (desktopVisible) setDesktopImages(card, img1, img2);
      if (mobileVisible) rebuildMobileSlides(card, img1, img2);
      if (!desktopVisible && !mobileVisible) {
        setDesktopImages(card, img1, img2);
        rebuildMobileSlides(card, img1, img2);
      }
    }

    // subtitle
    const subEl = card.querySelector("[data-gpcard-subtitle]");
    if (subEl) {
      const raw = (subtitle || "").trim();
      if (!raw || raw.toLowerCase() === "default title") {
        subEl.textContent = ""; subEl.hidden = true;
      } else {
        subEl.hidden = false;
        const parts = raw.split(" / ").map(s => s.trim()).filter(Boolean);
        if (parts.length > 1) {
          subEl.innerHTML = `<span class="gpcard__subtitleHi">${parts[0]}</span>` +
            parts.slice(1).map(p => ` <span>/ ${p}</span>`).join("");
        } else { subEl.textContent = raw; }
      }
    }

    // links
    const newUrl = handle ? ("/products/" + handle) : "";
    const mediaLink = card.querySelector(".gpcard__mediaLink");
    const titleLink = card.querySelector("[data-gpcard-title-link]");
    if (mediaLink && newUrl) mediaLink.href = newUrl;
    if (titleLink && newUrl) titleLink.href = newUrl;
    if (titleLink && title) titleLink.innerHTML = formatCardTitle(title);

    // prices (data-sp-price / compare already include strikethrough when active for the shopper)
    const priceNow = btn.getAttribute("data-sp-price") || "";
    const priceCompare = btn.getAttribute("data-sp-compare") || "";
    const onSale = btn.getAttribute("data-sp-onsale") === "1";
    const strikePct = btn.getAttribute("data-sp-strike") || "0";
    const priceEl = card.querySelector("[data-gpcard-price]");
    const compareEl = card.querySelector("[data-gpcard-compare]");
    const offEl = card.querySelector("[data-gpcard-off]");
    const priceWrap = card.querySelector("[data-gpcard-pricewrap]");
    if (priceWrap) priceWrap.setAttribute("data-gpcard-strike", strikePct);
    if (priceEl) priceEl.textContent = priceNow;
    if (compareEl) {
      if (onSale && priceCompare) { compareEl.hidden = false; compareEl.textContent = priceCompare; }
      else { compareEl.hidden = true; compareEl.textContent = ""; }
    }
    const offText = btn.getAttribute("data-sp-off") || "";
    if (offEl) {
      if (onSale && offText) { offEl.hidden = false; offEl.textContent = offText; }
      else { offEl.hidden = true; offEl.textContent = ""; }
    }

    // badge
    const badgeEl = card.querySelector("[data-gpcard-badge]");
    if (badgeEl) {
      if (badge && badge.trim()) {
        badgeEl.hidden = false; badgeEl.textContent = badge;
        if (badgeStyle && badgeStyle.trim()) badgeEl.setAttribute("style", badgeStyle);
        else badgeEl.removeAttribute("style");
      } else { badgeEl.hidden = true; badgeEl.textContent = ""; badgeEl.removeAttribute("style"); }
    }

    // wide available badge (per-color; not shown on wide-tagged products)
    const wideBadgeEl = card.querySelector("[data-gpcard-wide-badge]");
    if (wideBadgeEl) {
      const wideAvailable = btn.getAttribute("data-sp-wide-available") === "1";
      wideBadgeEl.hidden = !wideAvailable;
      let hasOtherBadge = false;
      card.querySelectorAll(".gpcard__badge:not([data-gpcard-wide-badge])").forEach((el) => {
        if (!el.hidden) hasOtherBadge = true;
      });
      wideBadgeEl.classList.toggle("gpcard__badge--offset", wideAvailable && hasOtherBadge);
    }

    // benefit
    const benEl = card.querySelector("[data-gpcard-benefit]");
    const benText = card.querySelector("[data-gpcard-benefit-text]");
    if (benEl) {
      if (benefit && benefit.trim()) {
        benEl.hidden = false; if (benText) benText.textContent = benefit;
      } else {
        benEl.hidden = true; if (benText) benText.textContent = "";
      }
    }

    // state
    card.dataset.activeHandle = handle || card.dataset.activeHandle || card.dataset.baseHandle || "";
    card.dataset.sizeIndex = String(sizeIndex);
    card.dataset.activeVariants = variantsEnc;

    // mobile QA button
    const quickBtn = card.querySelector(SELECTORS.qaQuickMobile);
    if (quickBtn && handle) {
      quickBtn.setAttribute("data-product-handle", handle);
      quickBtn.setAttribute("data-product-title", title || "");
    }

    buildSizesFromVariants(card, variantsEnc, sizeIndex);
  }

  function initCardsState(root) {
    const { SELECTORS, qsa: _qsa } = GOC;
    _qsa(root, SELECTORS.card).forEach((card) => {
      if (isNoSwatchCard(card)) { initNoSwatchCardImages(card); return; }
      const sw = card.querySelector(".gpcard__swatch.is-active") || card.querySelector(".gpcard__swatch");
      if (!sw) return;
      if (!cardHasRealImage(card)) applySwatchToCard(sw, card);
    });

    setTimeout(() => {
      _qsa(root, SELECTORS.card).forEach((card) => {
        if (isNoSwatchCard(card)) { initNoSwatchCardImages(card); return; }
        const sw = card.querySelector(".gpcard__swatch.is-active") || card.querySelector(".gpcard__swatch");
        if (!sw) return;
        if (!cardHasRealImage(card)) applySwatchToCard(sw, card);
      });
    }, 250);
  }

  Object.assign(GOC, {
    preloadImage, preloadSwatchImages, setDesktopImages, rebuildMobileSlides,
    cardHasRealImage, isNoSwatchCard, initNoSwatchCardImages,
    buildSizesFromVariants, applySwatchToCard, initCardsState
  });
})();
